<template>
	<!-- 琼浆玉露 -->
	<div class="qjylBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">琼浆玉露</p>
				</div>
			</div>
		</van-sticky>
		<div class="qjylBoxNum">
			<div class="qjylNum">
				<span>我的琼浆玉露</span>
				<span>{{userGiftLogAll.user_gift}}</span>
			</div>
			<div v-for="(item,idx) in userGiftLog">
				<div class="seleData">
					<span>{{item.month}}</span>
					<span><img src="../../assets/img/downarr.png" alt="" @click="xsqb(idx,item.mark)"></span>
				</div>
				<div class="itemInfoNum" ref="userGiftLogBox">
					<div class="itemBox" v-for="(itm,inx) in item.list">
						<div class="readBookNum">
							<span>读{{itm.name}}灌溉琼浆玉露{{itm.number}}瓶</span>
							<span v-if="itm.income_state == 2">-{{itm.number}}</span>
							<span v-if="itm.income_state == 1">+{{itm.number}}</span>
						</div>
						<p class="datatime"><span>{{formatDateTime(itm.createtime)}}</span></p>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="qjylTxt">
			<p>琼浆玉露投送：</p>
			<p>文章获得琼浆玉露的数量会加入积分统计，积分会影响作品曝光率，为你喜欢的大大投送吧!</p>
			<p>琼浆玉露的获得方式：</p>
			<p>1、连载V文，以及V章字数达到30万字的完结V文，不跳章进行购买，每满30万字可得琼浆玉露10瓶，60万字20瓶，以此类推，例：不跳章购买字数为51万，则获得琼浆玉露10瓶；</p>
			<p>2、V章字数不足30万字的完结V文，全文不跳章订阅后，按实际V章字数计算，每3万字可获得1瓶琼浆玉露，不足3万字按3万字计算，例如某完结文V章字数22万，全文不跳章订阅后，可获得8瓶琼浆玉露。</p>
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userGiftLog:[],
				userGiftLogAll:[],
				tapshowBox: true,
			}
		},
		created() {
			this.user_gift_log();
		},
		methods: {
			back() {
				this.$router.push('/userinfo')
			},
			// 全部显示
			xsqb(index, mark) {
				console.log(index, mark)
				this.userGiftLog[index].mark = !mark;
				this.tapshowBox = !mark;
				this.$refs.userGiftLogBox.forEach((i, idx) => {
					if (index == idx) {
						if (this.tapshowBox == false) {
							this.$refs.userGiftLogBox[idx].style.display = 'none';
						} else {
							this.$refs.userGiftLogBox[idx].style.display = 'block';
						}
					}
				})
			},
			user_gift_log(){
				this.$axios.post(this.$api.user_gift_log).then(res =>{
					console.log(res)
					this.userGiftLogAll =  res.data.data;
					var list = res.data.data.list;
					console.log(list,'list')
					Object.getOwnPropertyNames(list).forEach(key => {
						var new_list = [];
						for (var i in list) {
							new_list.push(list[i]);
						}
						this.userGiftLog = new_list;
					})
					this.userGiftLog.forEach(item => {
						console.log(item)
						Object.getOwnPropertyNames(item).forEach(key => {
							item['mark'] = true;
						})
					})
				})
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);
			
				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.qjylBox{
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		
		.qjylBoxNum {
			padding: 0 16px;
			background-color: #fff;
			padding-top: 30px;
			//我的琼浆玉露
			.qjylNum {
				margin-bottom: 20px;
				-webkit-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				-moz-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				border-radius: 15px;
				line-height: 80px;
				padding: 20px 30px;
				display: flex;
				font-weight: 600;
				color: #000000;
				font-size: 30px;/*px*/
				span{
					flex: 1;
				}
				span:last-child{
					text-align: right;
					color: #ff4081;
				}
			}
			//时间筛选
			.seleData {
				position: relative;
				span{
					line-height: 80px;
					display: inline-block;
					font-size: 30px;/*px*/
					padding-right: 10px;
					font-weight: 600;
				}
				img{
					vertical-align: center;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					width: 30px;
				}
			}
			.itemInfoNum{
				-webkit-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				-moz-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				border-radius: 15px;
				.itemBox{
					padding: 20px 30px;
					padding-bottom: 0;
					.readBookNum{
						display: flex;
						
						color: #000000;
						font-size: 30px;/*px*/
						padding-top: 20px;
						span{
							flex: 1;
							font-weight: 600;
						}
						span:last-child{
							text-align: right;
							color: #ff4081;
							font-weight: 400;
						}
					}
					.datatime{
						line-height: 80px;
						color: #a3a3a3;
						border-bottom: 1px solid #f0f0f0;/*no*/
						.time{
							padding-left: 10px;
						}
					}
				}
				.itemBox:last-child{
					.datatime{
						border-bottom: 0;
					}
				}
				
			}
		}
		
		.qjylTxt{
			margin: 30px 22px;
			padding: 20px 30px;
			border-radius: 15px;
			font-size: 30px;/*px*/
			line-height: 50px;/*px*/
			-webkit-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
			-moz-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
			box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
		}
	}

</style>
